import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
function CircularProgressWithLabel(props) {
    return (_jsx(Box, { sx: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '10px',
        }, children: props.child ? (props.child) : (_jsxs(_Fragment, { children: [_jsx(CircularProgress, { variant: "determinate", ...props }), _jsx(Box, { sx: {
                        top: '15%',
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }, children: _jsx(Typography, { variant: "caption", component: "div", color: "text.secondary", children: `${Math.round(props.value)}%` }) })] })) }));
}
export default function CircularWithValueLabel(props) {
    const { close, flagTheEnd, titleForError } = props;
    const [progress, setProgress] = useState(1);
    const addIntervalRef = useRef();
    useEffect(() => {
        addIntervalRef.current = setInterval(() => {
            setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 1));
        }, 1500);
        return () => {
            clearInterval(addIntervalRef.current);
        };
    }, []);
    useEffect(() => {
        if (progress === 100 && flagTheEnd) {
            clearInterval(addIntervalRef.current);
            close && setTimeout(() => close(), 1000);
        }
        if (flagTheEnd && progress > 10) {
            setProgress(100);
        }
        if (progress === 99 && !flagTheEnd) {
            clearInterval(addIntervalRef.current);
            close && setTimeout(() => close(), 1500);
        }
    }, [progress]);
    return (_jsx(CircularProgressWithLabel, { value: progress, child: progress === 99 && !flagTheEnd ? (_jsxs(Typography, { variant: "subtitle1", color: "textSecondary", children: ["\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A.. ", titleForError] })) : null }));
}
